import { render, staticRenderFns } from "./storeManage.vue?vue&type=template&id=08213795&"
import script from "./storeManage.vue?vue&type=script&lang=js&"
export * from "./storeManage.vue?vue&type=script&lang=js&"
import style0 from "./storeManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports